import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { bindActionCreators } from "redux";
import { getUserInfo, clearUserDetails } from "../../../actions/user";
import { updateCsaUserInfo } from "../../../actions/updUserInfo";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import { getWebSessionId } from "../../../actions/user";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { updateUserInfo as updateUser } from "../../../actions/user";
import {capillarySearchMember, clearCapillaryDetails, getEasyRewardsToken,registerCapillaryAccount,registerEasyAccount,updateCapillaryProfileMember,updateEasyProfileMember} from "../../../actions/easyRewards"
import {easyRewardsSearchMember} from "../../../actions/easyRewards"
import { updateUserInfo } from "../../../actions/updUserInfo";
import loadingImage from "../../../assets/images/loader.gif";
import axios from "axios";
import { updateUserAddr } from "../../../actions/updUserAddr";
const getStateCityZipUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-state-city-by-zipcode`;


function Update({
  connection_id,
  customer_name,
  userDetails,
  memberDetails,
  updatingUser,
  getUserInfo,
  getWebSessionId,
  updateCsaUserInfo,
  updateUser,
  updateUserInfo,
  updateEasyProfileMember,
  registerEasyAccount,
  clearUserDetails,
  clearCapillaryDetails,
  history,
  store_details,
  easyRewardsFlag,
  capillaryFlag,
  capillaryMemberDetails,
  configDetails,
  getEasyRewardsToken,
  capillarySearchMember,
  easyRewardsSearchMember,
  updateCapillaryProfileMember,
  registerCapillaryAccount,
  updateUserAddr
}) {

  const easyRewardsDetails =easyRewardsFlag === 'Y'  &&  memberDetails && memberDetails.data  ? memberDetails.data.MemberResponse ? memberDetails.data.MemberResponse : '' : ''
const capillaryData = capillaryFlag ==='Y' && capillaryMemberDetails && capillaryMemberDetails.data && capillaryMemberDetails.data.data.length > 0 ? capillaryMemberDetails.data.data[0].customer_details : ''

  const [mobileNo, setMobileNo] = useState("");
  
  const [consFirstName, setConsFirstName] = useState(capillaryFlag === 'Y' ? capillaryData && capillaryData.firstname ? capillaryData.firstname : "":easyRewardsFlag === 'Y' ? easyRewardsDetails ? easyRewardsDetails.FirstName : "" : userDetails ? userDetails.COM_FNAME : "");
  const [consLastName, setConsLastName] = useState(capillaryFlag === 'Y' ? capillaryData  && capillaryData.lastname? capillaryData.lastname : "":easyRewardsFlag === 'Y' ? easyRewardsDetails ? easyRewardsDetails.LastName : "" : userDetails ? userDetails.COM_LNAME : "");
  const [consEmailId, setConsEmailId] = useState(capillaryFlag === 'Y' ? capillaryData && capillaryData.email? capillaryData.email : "" :easyRewardsFlag === 'Y' ? easyRewardsDetails ? easyRewardsDetails.Email : "" : userDetails ? userDetails.COM_EMAIL_ID : "");
  const [saveButton ,setSaveButton]=useState(false)
  const [validator] = useState(new SimpleReactValidator(
    {

      messages: {
          regex: 'Enter Valid Email Address'
        },
        validators: {
          regex: {
            message: 'Enter Valid Email Address',
            rule: (val, params, validator) => {
              return /^(("[\w\s]+")|([\w\.]+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)

              ;
            },
            messageReplace: (message, params) => message.replace(':values', params)
          }
        }
  }
  ));
  const [validationMessagesVisible, setValidationMessagesVisible] = useState(false);

// 1️⃣ Fetch user data only once on load
useEffect(() => {
  const fetchData = async () => {
    const mobileNo = localStorage.getItem("mobile_no");
    if (!mobileNo) return;

    const options = {
      connection_id: connection_id,
      mobile_no: mobileNo,
    };

    if (easyRewardsFlag === "Y") {
      const data = {
        mobile_no: mobileNo,
        token: configDetails?configDetails.Token : "",
      };
      await easyRewardsSearchMember(data);
      await updateUser(options);
    }else if(capillaryFlag == 'Y'){
      let data = {
      mobile_no : mobileNo,
      connection_id:connection_id
    }
   await capillarySearchMember(data); 
   await updateUser(options);
    }
     else {
      await updateUser(options);
    }
  };

  fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [connection_id, store_details&&store_details.store_code, configDetails&&configDetails.Token]);


// 2️⃣ When Redux updates user/member details, update textboxes
useEffect(() => {
  if (easyRewardsFlag === "Y") {
    const easyData =
      memberDetails&&memberDetails.data?memberDetails.data.MemberResponse : null;

    if (easyData) {
      setConsFirstName(easyData.FirstName || "");
      setConsLastName(easyData.LastName || "");
      setConsEmailId(easyData.Email || "");
    }else {
       setConsFirstName( "");
      setConsLastName( "");
      setConsEmailId( "");
    }
  } else if(capillaryFlag == 'Y'){
 
const capillaryAlldata = capillaryMemberDetails && capillaryMemberDetails.data && capillaryMemberDetails.data.data.length > 0 ? capillaryMemberDetails.data.data[0].customer_details : null


    if (capillaryAlldata) {
      setConsFirstName(capillaryAlldata.firstname || "");
      setConsLastName(capillaryAlldata.lastname || "");
      setConsEmailId(capillaryAlldata.email || "");
    }else if(userDetails) {
      setConsFirstName(userDetails.COM_FNAME || "");
      setConsLastName(userDetails.COM_LNAME || "");
      setConsEmailId(userDetails.COM_EMAIL_ID || "");
    }else {
      setConsFirstName( "");
      setConsLastName( "");
      setConsEmailId( "");
  }

  }  else if (userDetails) {
    setConsFirstName(userDetails.COM_FNAME || "");
    setConsLastName(userDetails.COM_LNAME || "");
    setConsEmailId(userDetails.COM_EMAIL_ID || "");
  }else {
      setConsFirstName( "");
      setConsLastName( "");
      setConsEmailId( "");
  }
}, [memberDetails, userDetails, store_details&&store_details.store_code]);
const getStateCityByZipcode = async (zipValue) => {
  try {
    const res = await axios.get(getStateCityZipUrl, {
      params: {
        connection_id,
        zipcode: zipValue,
      },
    });


    if (res.data.ack === "Failure") {
      return [];
    } else {
      return res.data.results.data;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return []; // Return empty array in case of error
  }
};

const handleChange1 = async (event) => {
    let value = event.target.value;
    value = value.replace(/\D/g, "").slice(0, 10);
    setMobileNo(value);
    let len = store_details && store_details.tenant_name === 'D Samson Industries (Pvt) Ltd' ? 9 : 10;
    if (value.length === len) {
      let options = {
        connection_id: connection_id,
        mobile_no: value,
      };
     if(easyRewardsFlag === 'Y'){ let data = {
        mobile_no: value,
        token: configDetails && configDetails.Token ? configDetails.Token : ''
      }
      localStorage.setItem("mobile_no", value); 
   const res = await easyRewardsSearchMember(data);
   await updateUser(options);
   
    if(res && res.data && res.data.ReturnMessage) { 
 toast.error(`${res.data.ReturnMessage} please register consumer`);
            return;
         }
         
   
  }else if(capillaryFlag === 'Y'){
    let data = {
      mobile_no : value,
      connection_id:connection_id
    }
     localStorage.setItem("mobile_no", value); 
   let res =  await capillarySearchMember(data);
   if(res.data.data.length){
    let allData = res.data.data[0].customer_details;
    setConsEmailId(allData.email)
    setConsFirstName(allData.firstname)
    setConsLastName(allData.lastName)
     


   }else {
    setConsEmailId('')
    setConsFirstName('')
    setConsLastName('')
    
   }
  // res.data.length > 0 ? res.data.
//    await updateUser(options);
   
//     if(res && res.msg) { 
//  toast.error(`${res.msg} please register consumer`);
//             return;
//          }

  }


      await updateUser(options);
    }
  };

  const handleBack = () => {
    history.goBack();
  };
   

   const  handleRemove =async () => {
    clearUserDetails();
    await clearCapillaryDetails();
    localStorage.removeItem('newRegNumber');
    localStorage.removeItem("mobile_no");
    setMobileNo('');
    setConsFirstName('');
    setConsEmailId('');
    setConsLastName('');
    document.getElementById('mobile_no') && document.getElementById('mobile_no').focus();
    history.push("/update");     
  };

 // Inside handleSubmit function
const handleSubmit = async (event) => {
  // event.preventDefault(); // uncomment if inside form
  if (updatingUser) return;   // 🚫 prevent multiple clicks
  
//  setSaveButton(true)       // 🔒 lock button immediately

  try {

    const isEmailValid = consEmailId.trim() !== "";
const isFirstNameValid = consFirstName.trim() !== "";
const isFormValid = validator.allValid();
console.log(isFormValid,'isssss')
if(isFormValid){
if(customer_name == 'PUMA'){
if ( !isFirstNameValid ) {
   validator.showMessages();
   setValidationMessagesVisible(true);
   return;
 }
}else {
 if (!isEmailValid || !isFirstNameValid ) {
   validator.showMessages();
   setValidationMessagesVisible(true);
   return;
 }}


    const mobileNo =
      localStorage.getItem("newRegNumber") !== null
        ? localStorage.getItem("newRegNumber")
        : userDetails.COM_CONSUMER_MOBILE_NO;

    const options = {
      connection_id: connection_id,
      user_data: {
        cons_first_name: consFirstName,
        cons_last_name: consLastName,
        cons_email_id: consEmailId,
        cons_mobile_no: mobileNo,
      },
    };

    /* ---------------- EASY REWARDS FLOW ---------------- */
    if (easyRewardsFlag === "Y") {

      const data = {
        mobile_no: mobileNo,
        firstName: consFirstName,
        lastName: consLastName,
        emailId: consEmailId,
        username: "apiuser@BlissClub.com",
        store_code: store_details ? store_details.store_code : "",
        token:
          configDetails && configDetails.Token
            ? configDetails.Token
            : "",
        address1: "",
        address2: "",
        pinCode: "",
      };

      await updateEasyProfileMember(data);
      await registerEasyAccount(data);
    }

    /* ---------------- CAPILLARY FLOW ---------------- */
    else if (capillaryFlag === "Y") {

      const capillaryData =
        capillaryMemberDetails &&
        capillaryMemberDetails.data &&
        capillaryMemberDetails.data.data &&
        capillaryMemberDetails.data.data.length > 0
          ? capillaryMemberDetails.data.data[0].customer_details
          : "";

      let data;

      if (!capillaryData) {
        data = {
          connection_id: connection_id,
          mobile_no: mobileNo,
          firstName: consFirstName,
          lastName: consLastName,
          emailId: consEmailId,
          address1: userDetails.COM_ADDRESS1,
          address2: userDetails.COM_ADDRESS2,
          address3: userDetails.COM_ADDRESS3,
          stateName: userDetails.COM_STATE_NAME,
          countryName: userDetails.COM_CONTRY_NAME,
          townName: userDetails.COM_TOWN_NAME,
          pinCode: userDetails.COM_PIN,
        };
      } else {
        data = {
          connection_id: connection_id,
          mobile_no: mobileNo,
          firstName: consFirstName,
          lastName: consLastName,
          emailId: consEmailId,
          address1: capillaryData.custom_fields.addressone,
          address2: capillaryData.custom_fields.addresstwo,
          address3: capillaryData.custom_fields.addressthree,
          stateName: capillaryData.state,
          countryName: capillaryData.country_of_residence,
          townName: capillaryData.city,
          pinCode: capillaryData.zip,
        };
      }
let registerResponse = await registerCapillaryAccount(data);
 let registerData = registerResponse && registerResponse.data &&  registerResponse.data.length > 0 ? registerResponse.data[0] : null;
      if(registerData){
        const storedMobile = "91" + String(localStorage.getItem("mobile_no"));
const apiMobile = String(registerData.customer_details.mobile);

if (apiMobile === storedMobile) {
         
            await updateCapillaryProfileMember(data)
          await updateUserInfo(options);
        

        }else {
                toast.error('Mail address is existing in thirdparty, please update profile with correct mail address');
                
                return;
        }

      }
      

      if (capillaryData) {

        const pinCodeDetails = await getStateCityByZipcode(data.pinCode);

        const addOptions = {
          connection_id: connection_id,
          ship_country_name: pinCodeDetails.CON_NAME,
          ship_country_id: pinCodeDetails.PNM_COUNTRY_CD,
          ship_state_name: pinCodeDetails.LPN_STATE_NAME,
          ship_state_id: pinCodeDetails.PNM_STATE_CD,
          ship_town_name: pinCodeDetails.LPN_TOWN_NAME,
          ship_town_id: pinCodeDetails.PNM_TOWN_CD,
          bill_country_name: pinCodeDetails.CON_NAME,
          bill_country_id: pinCodeDetails.PNM_COUNTRY_CD,
          bill_state_name: pinCodeDetails.LPN_STATE_NAME,
          bill_state_id: pinCodeDetails.PNM_STATE_CD,
          bill_town_name: pinCodeDetails.LPN_TOWN_NAME,
          bill_town_id: pinCodeDetails.PNM_TOWN_CD,
          bill_addr_1: data.address1,
          bill_addr_2: data.address2,
          bill_addr_3: data.address3,
          bill_pin: data.pinCode,
          ship_addr_1: data.address1,
          ship_addr_2: data.address2,
          ship_addr_3: data.address3,
          ship_pin: data.pinCode,
          cons_mobile_no: mobileNo,
        };

        await updateUserAddr({
          connection_id: connection_id,
          user_data: addOptions,
        });
      }
    }

    /* ---------------- NORMAL FLOW ---------------- */
    else {
      await updateUserInfo(options);
    }

    /* ---------------- REFRESH USER ---------------- */

    const user = {
      connection_id: connection_id,
      mobile_no: mobileNo,
    };

    setTimeout(function () {
      updateUser(user);
    }, 1000);

    setTimeout(function () {
      if (localStorage.getItem("lot_code")) {
        history.push("/PD/" + localStorage.getItem("lot_code"));
        localStorage.removeItem("lot_code");
      } else {
        history.goBack();
      }
    }, 3000);
    } else {
           validator.showMessages();
   setValidationMessagesVisible(true)
        }

  } catch (error) {
    console.error("Submit Error:", error);
  } finally {
    setSaveButton(false);   // 🔓 unlock button
  }
};


  

  const handleChange = (event) => {
    const { id, value } = event.target;
    switch (id) {
      case "cons_first_name":
        setConsFirstName(value);
        break;
      case "cons_last_name":
        setConsLastName(value);
        break;
      case "cons_email_id":
        setConsEmailId(value);
        break;
      default:
        break;
    }
  };
  const handleNext=async ()=>{

const errorMessages = validator.getErrorMessages();

const filteredErrors = Object.fromEntries(
  Object.entries(errorMessages).filter(([key, value]) => key !== "phone")
);
    if (filteredErrors.first_name === null && filteredErrors.email === null) {
    localStorage.setItem('conMobileNo',localStorage.getItem("newRegNumber") !== null
            ? localStorage.getItem("newRegNumber")
            : userDetails.COM_CONSUMER_MOBILE_NO);
    localStorage.setItem('conFirstName',consFirstName);
    localStorage.setItem('conLastName',consLastName);
    localStorage.setItem('conEmailId',consEmailId);
    localStorage.setItem('newConsumer',easyRewardsDetails &&  easyRewardsDetails ? 'N' : "Y")
    history.push("/profile/edit-address");

    }else {
        validator.showMessages();
      setValidationMessagesVisible(true);
      
    }

  }
  
  
  return (
    <div>
      <Helmet>
        <title>{customer_name} | Consumer</title>
        <meta name="description" content="store" />
      </Helmet>
      <section className="tab-product m-0">
        <div className="container" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="row justify-content-center">
            <div className="col-sm-12 col-lg-6">
              <Tabs className="tab-content nav-material" style={{ padding: 15 }}>
                <TabList className="nav nav-tabs nav-material">
                  <Tab className="nav-item" style={{ width: "100%" }}>
                    <span className="nav-link" style={{ fontSize: 18, fontWeight: "bold" }}>
                      <i className="icofont icofont-contacts"></i>Update Consumer Details
                    </span>
                    <div className="material-border"></div>
                  </Tab>
                </TabList>
                <TabPanel>
                  {localStorage.getItem("mobile_no") ? (
                    <form className="theme-form mt-4" >
                      <div className="form-row">
                        <div className="col-md-12">
                          <label htmlFor="name">First Name</label>
                          <input
                            className="form-control"
                            type="text"
                            id="cons_first_name"
                            value={consFirstName}
                            onChange={(e) => handleChange(e)}
                            autoComplete="new"
                          />
                          {validator.message("first_name", consFirstName, "required|alpha_space")}
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="email">Last Name</label>
                          <input
                            className="form-control"
                            type="text"
                            id="cons_last_name"
                            value={consLastName}
                            onChange={(e) => handleChange(e)}
                            autoComplete="new"
                          />
                          {/* {validator.message("last name", consLastName, "required|alpha")} */}
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="review">Email</label>
                          <input
                            className="form-control"
                            type="text"
                            id="cons_email_id"
                            value={consEmailId}
                            onChange={(e) => handleChange(e)}
                            autoComplete="new"
                          />

                          {/* {validator.message("email", consEmailId, "required|email")} */}
                         { customer_name != 'PUMA' && validator.message(              'email',
              consEmailId,
              'required|regex',{
                messages: {
                  // required: 'Please provide a Email.',
              },
              }
            )} 
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="review">Mobile No</label>
                          <input
                            className="form-control"
                            type="text"
                            id="cons_mobile_no"
                            value={
                              localStorage.getItem("newRegNumber") !== null
                                ? localStorage.getItem("newRegNumber")
                                : localStorage.getItem("mobile_no")
                            }
                            readOnly
                          />
                        </div>
                        <div className="col-md-12" style={{ paddingBottom: 100 }}>
                          <div className="pull-right">
                            <button
                              type="button"
                              className="btn btn-solid"
                              style={{ marginRight: 10 }}
                              onClick={() => handleBack()}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className="btn btn-solid"
                              style={{ marginRight: 10 }}
                              onClick={() => handleRemove()}
                            >
                              Reset
                            </button>
                            {easyRewardsFlag != 'Y' ? 
                            <button
                              type="button"
                              className="btn btn-solid"
                              disabled={updatingUser}
                              onClick={(e)=>handleSubmit(e)}
                            >
                              {updatingUser  ? (
                                <img
                                  src={loadingImage}
                                  width={20}
                                  height={20}
                                  alt=""
                                  style={{ verticalAlign: "middle" }}
                                />
                              ) : (
                                "Save"
                              )}
                            </button> :
                          
                            <button type="button"
                              className="btn btn-solid" onClick={(e)=>handleNext(e)}>Next</button> }

                            &nbsp; &nbsp;
                          </div>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <form className="theme-form mt-4">
                      <div className="form-row">
                        <div className="col-md-12" style={{ textAlign: "center", paddingBottom: 0, paddingTop: 20 }}>
                        </div>
                        <div className="col-md-12">
                          <label>Mobile No</label>
                        </div>
                        <div className="col-md-12">
                          <input
                            type="text"
                            className="form-control text-padd"
                            id="mobile_no"
                            maxLength={ store_details && store_details.tenant_name == 'D Samson Industries (Pvt) Ltd' ? 9 : 10}
                            placeholder="Enter Mobile Number To Proceed"
                            value={mobileNo}
                            onChange={(e) => handleChange1(e)}
                            autoFocus={true}
                          />

                          {validator.message("phone", mobileNo, "required|phone")}
                        </div>
                        <div className="col-md-12">
                          <label>First Name</label>
                        </div>
                        <div className="col-md-12">
                          <input
                            type="text"
                            className="form-control text-padd"
                            readOnly
                          />
                        </div>
                        <div className="col-md-12" style={{ paddingBottom: 0 }}>
                          <label>Last Name</label>
                        </div>
                        <div className="col-md-12" style={{ paddingBottom: 0 }}>
                          <input
                            type="text"
                            className="form-control text-padd"
                            onChange={(e) => handleChange(e)}
                            readOnly
                          />
                        </div>
                        <div className="col-md-12">
                          <label>Email</label>
                        </div>
                        <div className="col-md-12" style={{ paddingBottom: 30 }}>
                          <input
                            type="text"
                            className="form-control text-padd"
                            onChange={(e) => handleChange(e)}
                            readOnly
                          />
                        </div>
                      </div>
                    </form>
                  )}
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => ({
  isAuth: state.user.isAuth,
  error: state.user.error,
  connection_id: state.tenant.connection_id,
  customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
  easyRewardsFlag: state.tenant.tenant_details.easy_rewards_flg || "N",
  capillaryFlag :  state.tenant.tenant_details.capillary_flg || "N",
  userDetails: state.user.user_details,
  memberDetails:state.easyRewards.memberDetails,
  capillaryMemberDetails : state.easyRewards.capillaryMemberDetails,
  updatingUser: state.updateUser.loading,
  store_details: state.tenant.store_details,
  configDetails: state.tenant.configDetails
});  
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getUserInfo,updateUserAddr, getWebSessionId,updateEasyProfileMember,capillarySearchMember,registerEasyAccount,registerCapillaryAccount,updateCapillaryProfileMember, updateCsaUserInfo,getEasyRewardsToken,easyRewardsSearchMember, updateUser, updateUserInfo, clearUserDetails,clearCapillaryDetails },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Update));
